module.exports = __webpack_public_path__ + "img/Maattekening dubbelwerkende cilinder met Frontflens.c06c3ae9.jpg";